import { forwardRef, type PropsWithChildren } from "react";

import clsx from "clsx";

import { Button, type ButtonProps } from "./button";

export { type ButtonProps as IconButtonProps } from "./button";

export const IconButton = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<ButtonProps>
>(({ size = "lg", className, children, ...props }, ref) => {
  return (
    <Button
      ref={ref}
      className={clsx(
        "rounded-md p-0",
        {
          "w-8": size === "sm",
          "w-9": size === "lg",
        },
        className,
      )}
      size={size}
      {...props}
    >
      {children}
    </Button>
  );
});
